import { HStack, Tag, TagLabel, Text } from '@chakra-ui/react';

import type { User as UserType } from '@/client/types/User';
import { useTranslation } from 'react-i18next';

interface SkillsSectionProps {
  userData: UserType;
}

export default function SkillsSection({ userData }: SkillsSectionProps) {
  const { t } = useTranslation();
  const { skills } = userData;

  return skills.length > 0 ? (
    <HStack spacing={2} flexWrap="wrap">
      {skills.map((skill) => (
        <Tag key={`${skill._id}-${skill.name}`} variant="warmNeutral">
          <TagLabel>{skill.name}</TagLabel>
        </Tag>
      ))}
    </HStack>
  ) : (
    <Text fontSize="16px" fontWeight={400} textDecoration="italic" color="neutral.800">
      {t('learners.profile.userDetails.noSkills')}
    </Text>
  );
}
